// services/stations.js
import axiosInstance from './axiosInstance';

const STATIONS_API_URL = '/stations';

const stationsService = {
  async getServers(idempresa, idposto = null, idstation = null) {
    try {
      let url = `${STATIONS_API_URL}/servers/get.php?idempresa=${idempresa}`;
      if (idposto) url += `&idposto=${idposto}`;
      if (idstation) url += `&idstation=${idstation}`;
      
      const response = await axiosInstance.get(url);
      return response.data !== "NOK" ? response.data : {};
    } catch (error) {
      console.error('Erro ao obter servidores:', error);
      return {};
    }
  }
};

export default stationsService;
